import { BookAnInspectionInterface } from "./BookAnInspectionPage.Interface";
import BookInspectionFormBuilder from "./components/Formbuilder/BookInspectionFormBuilder";
import "./BookAnInspectionPage.css";

const BookAnInspectionPage = ({
  config,
  errors,
  setErrors,
}: BookAnInspectionInterface) => {
  return (
    <>
      {config?.elements?.map((config, index) => (
        <div className={config.id} key={index}>
          {config?.fields?.map((field, index) => (
            <BookInspectionFormBuilder
              key={index}
              field={field}
              errors={errors}
              setErrors={setErrors}
            />
          ))}
        </div>
      ))}
    </>
  );
};
export default BookAnInspectionPage;
